// Import utilities for the api.
import { getUserAgent, trigger } from './Helpers';

/**
 * The main api class that constructs all other components.
 *
 * @since 5.0.0
 */
export default class Shutdown {
	/**
	 * "Class" constructor in ES6.
	 *
	 * @since 5.0.0
	 */
	constructor() {
		// Set some default variables for the class.
		this.ie = /MSIE/.test(getUserAgent()) || (!!window.MSInputMethodContext && !!document.documentMode);
		this.ua = getUserAgent().toLowerCase();
		this.preventAll = false;

		// Initialize!
		this.init();
	}

	/**
	 * A default method to initialize the class.
	 *
	 * @since 5.0.0
	 *
	 * @returns {void}
	 */
	init() {
		trigger(document, 'Shutdown.init', {
			Shutdown: this,
		});

		// If this flag is set for any reason, we need to prevent any campaigns from loading.
		if (this.preventAll) {
			const e = new Error('Campaigns have been prevented from loading.');
			e.type = 'debug';
			throw e;
		}

		// If this is IE, we need to exit now. No likey IE <= 11.
		if (this.ie) {
			throw 'An incompatible browser has been detected.';
		}

		// If this is a Googlebot crawler request, exit now.
		if (-1 < this.ua.indexOf('googlebot')) {
			throw 'An incompatible crawler has been detected.';
		}
	}
}
